<template>
  <UContainer>
    <UCard class="mt-10 overflow-hidden shadow-lg p-0">
      <template #header>
        <div class="p-4 pb-0">
          <h1>
            <ULink
              :to="buildUrl(props.newsItem.id)"
              target="_blank"
              :rel="null"
              class="font-bold text-lg text-black dark:text-white"
              >{{ props.newsItem.title || "Sin título" }}</ULink
            >
          </h1>
        </div>
      </template>
      <div class="flex flex-col md:flex-row">
        <div
          v-if="props.newsItem.image_link"
          class="img_preview w-full md:w-2/5"
        >
          <NuxtImg
            :src="props.newsItem.image_link"
            :alt="`Alt-${props.newsItem.title || 'Sin título'}`"
            loading="lazy"
            class="w-full h-48 md:h-64 object-cover"
          />
        </div>
        <div
          class="w-full flex flex-col justify-between space-y-3 pt-4 px-4 md:pt-0 md:px-6 md:w-3/5"
        >
          <p @click="toggleExpand()">
            <span
              class="text-container"
              :class="isExpanded ? 'md:max-h-96' : 'line-clamp-3 md:max-h-none md:line-clamp-none max-h-20'"
              >{{
                props.newsItem.sumarize_text ||
                props.newsItem.description ||
                "Sin contenido"
              }}</span
            >
            <span v-if="!isExpanded" class="text-blue-600 cursor-pointer md:hidden"
              >Ver más</span
            >
          </p>
          <div>
            <div
              class="flex justify-between items-center text-sm text-neutral-500 pt-2"
            >
              <UBadge
                v-if="props.newsItem.category_id"
                color="primary"
                variant="outline" 
                size="md"
                class="rounded-full"
              >
                <ULink :to="`/${getCategoryslug(props.newsItem.category_id)}`" class="text-primary-300">
                  {{ getCategoryName(props.newsItem.category_id) }}
                </ULink>
              </UBadge>
              <span>{{ formatLocalDate(props.newsItem.created_at) }}</span>
            </div>
            <UButton
              class="w-full mt-4 flex justify-center text-lg md:text-base md:w-auto rounded-md px-3.5 py-2.5"
              color="tertiary"
              variant="solid"
              size="md"
              :to="props.newsItem.link || buildUrl(props.newsItem.id)"
              :rel="null"
              target="_blank"
            >
              Leer noticia original
            </UButton>
          </div>
        </div>
      </div>
    </UCard>
  </UContainer>
</template>

<script lang="ts" setup>
import { getCategoryColor, getCategoryName } from "~/utils/categories";
import buildUrl from "~/utils/buildUrl";
import type { NewsItem } from "~/types/news";

const props = defineProps<{
  newsItem: NewsItem;
}>();

const isExpanded = ref(false);

const toggleExpand = () => (isExpanded.value = !isExpanded.value);

const formatLocalDate = (stringDate: string) => {
  const date = new Date(stringDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
</script>

<style>
.text-container {
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

@media (min-width: 768px) {
  .text-container {
    font-size: 1rem;
  }
}

@media (max-width: 767px) {
  .text-container {
    font-size: 0.875rem;
  }
}
</style>
